import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import { useEffect } from "react";
import { setRedirectStatus } from "sources/suitableOrders";

export default function ForwardingSuitableOrder(props) {
    useEffect(() => {
        const { orderId, matchingId } = paramsObject(props.location.search);
        setRedirectStatus({ matchingId }).then(() => {
            location.replace(
                `${paths.forwardingLogin}?serverKey=${window.location.hostname}&token=${localStorage.getItem("token")}&redirectUrl=%2FtransporterOrders%2F${orderId}?matchingId=${matchingId}`,
            );
        });
    }, []);
    return null;
}
